import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 6a2 2 0 1 0 -4 0m6.506 6.506l3.461 1.922a2 2 0 0 1 1.029 1.749v.823m-2 2h-14a2 2 0 0 1 -2 -2v-.823a2 2 0 0 1 1.029 -1.749l6.673 -3.707","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconHangerOff = createReactComponent('outline', 'hanger-off', 'HangerOff', __iconNode);

export default IconHangerOff;